import React, { useState, useEffect } from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap';
import { DatePicker, Form, InputPicker, Schema } from 'rsuite';
import FormActionButtons from '../../../../../Shared/FormAction/FormActionButtons';
import { getStates } from '../../../../../../services/Shared/codeTable.service'
import Information from '../../../../../Shared/Card/Information';
import applicationService from '../../../../../../services/Public/Application/LSI/lsiApplication.service';
import examinationService from '../../../../../../services/Public/Application/LSI/examination.service'
import { GetAppInformationContent } from '../../../../../Shared/InformationContent/LsiInformation';
import LoadingSpinner from '../../../../../Shared/GenericComponents/LoadingSpinner';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import Issues from '../../../../../Shared/Card/Issues';
import { AccessibleInputPicker } from '../../../../../Shared/GenericComponents/AccessibleComponents';

function ExaminationVerification() {
    const [states, setStates] = useState([])
    const routes = useSelector(x => x.currentRoutes);
    const appId = useSelector(x => x.currentApplicationId);
    const entityId = useSelector(x => x.userInfo.EntityId)
    const sectionId = 11;
    const [formModel, setFormModel] = useState({
        id: 0,
        applicationId: appId,
        entityId: entityId,
        jurisdictionState: null,
        dateOfExam: null,
        userCrte: "",
        dateCrte: new Date(),
        deleted: false
    });
    const [sectionData, setSectionData] = useState({});
    const [hasLoaded, setHasLoaded] = useState(false);
    const push = useNavigate();
    const { DateType, ObjectType } = Schema.Types;
    const model = Schema.Model({
        jurisdictionState: ObjectType().isRequired('This field is required.'),
        dateOfExam: DateType('Please enter a valid date.').isRequired('This field is required.')
    });
    useEffect(() => {
        getStates().then(setStates);
        examinationService.getExamination(appId).then((response) => {
            if (response.data) {
                setFormModel({
                    ...response.data,
                    dateOfExam: response.data.dateOfExam != null ? new Date(response.data.dateOfExam) : null
                });
            }
            applicationService.lsiGetSection(appId, sectionId).then((data) => {
                setSectionData(data.data);
                setHasLoaded(true);
            })
        })
    }, [])
    const formSubmit = () => {
        examinationService.postExamination(formModel).then((response) => {
            if (response.data) {
                nextSectionNavigation()

            }
        })
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route);
    }
    return (
        <Container fluid>
            <strong>Land Surveyor Intern Application</strong>
            <h4 className="mb-3">Examination</h4>
            <Information content={GetAppInformationContent("exam")} />
            <br />
            {hasLoaded ?
                <Form readOnly={!sectionData.isUserEditable} fluid model={model} formValue={formModel} onChange={setFormModel} onSubmit={formSubmit}>
                    <Card className="mb-3">
                        <Card.Header>
                            Fundamentals Exam (FS)
                        </Card.Header>
                        <Card.Body>
                            <Row className="mb-3">
                                <Form.Group>
                                    <Col sm={3}>
                                        <Form.ControlLabel>Jurisdiction</Form.ControlLabel>
                                    </Col>
                                    <Col>
                                        <Form.Control
                                            accepter={AccessibleInputPicker}
                                            ariaLabel="Jurisdiction"
                                            placeholder="Please Select"
                                            block
                                            data={states}
                                            name="jurisdictionState"
                                            searchBy={(userInput, label, dataItem) => { if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput) return true; }} />
                                    </Col>
                                    <Form.HelpText className="d-none">Jurisdiction</Form.HelpText>
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group>
                                    <Col sm={3}>
                                        <Form.ControlLabel>Date (mm/dd/yyyy)</Form.ControlLabel>
                                    </Col>
                                    <Col>
                                        <Form.Control
                                            accepter={DatePicker}
                                            oneTap
                                            format="MM/dd/yyyy"
                                            block
                                            name="dateOfExam"
                                            placeholder=" "
                                        >
                                        </Form.Control></Col>
                                    <Form.HelpText className="d-none">Date of Exam</Form.HelpText>
                                </Form.Group>
                            </Row>
                        </Card.Body>
                    </Card>
                    <br />
                    <Issues isUserEditable={true} type={1} sectionId={sectionData.id} />
                    <FormActionButtons
                        nextSectionCallback={nextSectionNavigation}
                        isReadOnly={!sectionData.isUserEditable}
                        backToSectionLink="/individual/lsiApp/sections" />
                </Form> : <LoadingSpinner />
            }
        </Container>
    );
}
export default ExaminationVerification